import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAl_qeYQFZvPg5B2OBkhtBjvkM2vcFTSS8",
  authDomain: "psychic-diorama-468314-e2.firebaseapp.com",
  projectId: "psychic-diorama-468314-e2",
  storageBucket: "psychic-diorama-468314-e2.firebasestorage.app",
  messagingSenderId: "470723603055",
  appId: "1:470723603055:web:9fc25fac7464caefaa3b9a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

// Initialize Firebase Storage and get a reference to the service
const storage = getStorage(app);

export { db, storage };
